import { render, staticRenderFns } from "./relateUserDialog.vue?vue&type=template&id=985dc0b6&scoped=true&"
import script from "./relateUserDialog.vue?vue&type=script&lang=js&"
export * from "./relateUserDialog.vue?vue&type=script&lang=js&"
import style0 from "./relateUserDialog.vue?vue&type=style&index=0&id=985dc0b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985dc0b6",
  null
  
)

export default component.exports